// État de session partagé : une réponse 401 sur n'importe quelle requête affiche ETAT-08 en superposition bloquante
// (CMP-AppShell « Session expirée : superposition bloquante vers ACC-P07 »). La saisie en cours n'est pas perdue.
import { useSyncExternalStore } from 'react';

let expired = false;
const listeners = new Set<() => void>();

export const session = {
  markExpired(): void {
    if (expired) return;
    expired = true;
    listeners.forEach((listener) => listener());
  },
  reset(): void {
    expired = false;
    listeners.forEach((listener) => listener());
  },
  isExpired: (): boolean => expired,
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useSessionExpired(): boolean {
  return useSyncExternalStore(session.subscribe, session.isExpired, () => false);
}
